import axios from 'axios';

export const api = axios.create({
  baseURL: 'https://ia.datafort.com.br:8443/api',
  // baseURL: 'http://localhost:8443/api',



});